// Anti-collision des crans de guess (.mashup-tick).
// Plusieurs joueurs qui valident au meme moment ont des fractions tres proches
// et leurs avatars se superposent au meme endroit. On calcule ici un decalage
// horizontal (dodge) en pixels par cran, sans toucher au `left` (donc la base
// reste alignee sur la barre : on ne modifie que le transform).
//
// Meme motif reutilise par MashupRound (mode audio / blind test) et ChronoRound
// (frise temporelle). Retourne un objet { [pseudo]: dodgePx }.
//
// Strategie : on trie par fraction croissante, on regroupe en "clusters" les
// crans dont l'ecart de fraction est <= threshold, puis on repartit chaque
// cluster de facon symetrique autour de 0 (ex 3 crans -> -step, 0, +step).
export function computeTickDodge(ticks = [], { threshold = 0.07, step = 34 } = {}) {
  const items = (ticks || [])
    .map((tk, idx) => ({
      key: tk && tk.pseudo,
      idx,
      f: Math.max(0, Math.min(1, Number(tk && tk.fraction) || 0)),
    }))
    .filter((it) => it.key != null)
    .sort((a, b) => a.f - b.f || a.idx - b.idx);

  const dodge = {};
  let group = [];

  const flush = () => {
    const n = group.length;
    for (let k = 0; k < n; k++) {
      // Offsets symetriques centres sur la position du groupe.
      dodge[group[k].key] = Math.round((k - (n - 1) / 2) * step);
    }
    group = [];
  };

  for (const it of items) {
    // Nouveau cluster des que l'ecart avec le voisin precedent depasse le seuil.
    if (group.length && it.f - group[group.length - 1].f > threshold) flush();
    group.push(it);
  }
  flush();

  return dodge;
}
